import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiInterfaceService } from 'apps/driver-dashboardfe/src/app/core/services/api-interface/api-interface.service';
import { LoaderService } from 'apps/driver-dashboardfe/src/app/core/services/loader/loader.service';

@Component({
    standalone: false,
    selector: 'octo-unsubscribe',
    templateUrl: './unsubscribe.component.html',
    styleUrls: ['./unsubscribe.component.scss'],
})
export class UnsubscribeComponent implements OnInit {
    isDirect: any = false;
    showLoader: boolean = false;
    isSubmit: boolean = false;
    token: any;

    constructor(
        private activatedRoute: ActivatedRoute,
        private apiService: ApiInterfaceService
    ) {}

    ngOnInit(): void {
        this.activatedRoute.queryParams.subscribe((params) => {
            this.token = params['pt'];
            if (params['pt'] && params['direct'] === 'true') {
                this.unsubscribe();
            }
        });
    }

    checkValue(event: any) {
        if (event.target?.value?.toLowerCase() === 'unsubscribe') {
            this.isSubmit = true;
        } else {
            this.isSubmit = false;
        }
    }

    unsubscribe() {
        this.showLoader = true;
        this.apiService
            .get(`driver/unsubscribe/`, {
                token: this.token,
            })
            .subscribe((res: any) => {
                this.showLoader = false;
                this.isDirect = 'true';
            });
    }
}
